import { useEffect, useState } from 'react';
import { type Place, type Template } from '@torapon/shared';
import { api, HttpError } from '../lib/api';
import { Dialog, useToast } from '../components/ui';
import { useDirectory, useNames } from '../lib/directory';
import { deleteTemplateDoc } from '../lib/fs';
import { PlaceDialog } from '../components/PlaceDialog';

/** お気に入り・ひな形の管理（仕様書「お気に入り・ひな形の管理」）：登録した場所とルートの編集・削除 */
export function PlacesPage() {
  const toast = useToast();
  const dir = useDirectory();
  const names = useNames();
  const [places, setPlaces] = useState<Place[] | null>(null);
  const [templates, setTemplates] = useState<Template[] | null>(null);
  const [edit, setEdit] = useState<Place | 'new' | null>(null);
  const [del, setDel] = useState<Template | null>(null);
  const load = () => {
    api.get<{ places: Place[] }>('/v1/office/places').then((r) => setPlaces(r.places));
    api.get<{ templates: Template[] }>('/v1/office/templates').then((r) => setTemplates(r.templates));
  };
  useEffect(load, []);
  const sorted = [...(places ?? [])].sort((a, z) => names.place(a.id).localeCompare(names.place(z.id), 'ja'));
  const remove = async (t: Template) => {
    try { await api.del(`/v1/office/templates/${t.id}`); await deleteTemplateDoc(t.id).catch(() => {}); toast('ひな形を消しました'); setDel(null); load(); }
    catch (e) { toast(e instanceof HttpError ? e.message : '消せませんでした'); }
  };
  return (
    <div className="page" style={{ display: 'grid', gap: 16 }}>
      <section className="panel">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px 0' }}><b>場所（ピックアップ先・ドロップ先）</b><button className="btn pri" onClick={() => setEdit('new')}>＋ 場所を追加</button></div>
        <table>
          <thead><tr><th>名前</th><th>住所・電話</th><th>荷積み・荷下ろし</th><th>お気に入り</th><th></th></tr></thead>
          <tbody>
            {places === null ? <tr><td colSpan={5} className="muted">読み込み中…</td></tr>
              : sorted.length === 0 ? <tr><td colSpan={5} className="muted">まだ場所がありません</td></tr>
              : sorted.map((p) => { const d = dir.places.get(p.id); return (
                <tr key={p.id}><td><b>{d?.name ?? '—'}</b>{d?.memo && <small>{d.memo}</small>}</td><td>{d?.address ?? '—'}<small className="num">{d?.phone ?? ''}</small></td>
                  <td className="num">{p.loadMin} 分・{p.unloadMin} 分</td><td>{p.isFavorite ? <span className="pill ok">お気に入り</span> : '—'}</td>
                  <td><button className="btn sm" onClick={() => setEdit(p)} aria-label={`${d?.name ?? ''} を直す`}>直す</button></td></tr>
              ); })}
          </tbody>
        </table>
      </section>
      <section className="panel">
        <div style={{ padding: '14px 16px 0' }}><b>ひな形</b><small className="muted" style={{ marginLeft: 8 }}>配送指示の画面の「ひな形に保存」で作れます</small></div>
        <table>
          <thead><tr><th>名前</th><th>行き先</th><th></th></tr></thead>
          <tbody>
            {templates === null ? <tr><td colSpan={3} className="muted">読み込み中…</td></tr>
              : templates.length === 0 ? <tr><td colSpan={3} className="muted">まだひな形がありません</td></tr>
              : templates.map((t) => (
                <tr key={t.id}><td><b>{names.template(t.id)}</b></td><td>{t.stops.map((s) => `${s.kind === 'pickup' ? '積' : '届'}：${names.place(s.placeId)}`).join(' → ')}</td>
                  <td><button className="btn sm danger" onClick={() => setDel(t)} aria-label={`${names.template(t.id)} を消す`}>消す</button></td></tr>
              ))}
          </tbody>
        </table>
      </section>
      {edit && <PlaceDialog place={edit === 'new' ? null : edit} onClose={() => setEdit(null)} onDone={() => { setEdit(null); load(); }} />}
      {del && (
        <Dialog title={`ひな形「${names.template(del.id)}」を消しますか？`} onClose={() => setDel(null)}>
          <p style={{ margin: 0 }}>送った配送には影響しません。</p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}><button className="btn" onClick={() => setDel(null)}>やめる</button><button className="btn danger" onClick={() => remove(del)}>消す</button></div>
        </Dialog>
      )}
    </div>
  );
}

